import { MapPin, Home } from 'lucide-react';
import { useCustomerAddresses } from 'features/customer/hooks/useCustomerAddresses';

const AddressesTab = ({ customerId }) => {
  const { data, isPending, isError, error } = useCustomerAddresses(customerId);
  const addresses = data?.data?.addresses || [];

  if (isPending) {
    return (
      <div className='bg-card border border-border rounded-lg p-6'>
        <div className='text-center py-8'>
          <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto'></div>
          <p className='mt-2 text-muted-foreground text-sm'>Loading addresses...</p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className='bg-card border border-border rounded-lg p-6'>
        <p className='text-destructive text-center py-8'>
          Error loading addresses: {error?.message || 'Something went wrong'}
        </p>
      </div>
    );
  }

  return (
    <div className='bg-card border border-border rounded-lg p-6'>
      <h2 className='text-lg font-semibold mb-4 flex items-center'>
        <MapPin className='mr-2' size={20} />
        Customer Addresses
      </h2>
      {addresses.length > 0 ? (
        <div className='space-y-4'>
          {addresses.map((address) => (
            <div key={address._id} className='border border-border rounded-lg p-4 hover:bg-accent/50 transition-colors'>
              <div className='flex items-start justify-between'>
                <div className='flex-1'>
                  <div className='flex items-center gap-2 mb-2'>
                    <Home size={16} className='text-muted-foreground' />
                    <h3 className='font-medium text-sm capitalize'>{address.addressType || 'Address'}</h3>
                    {address.isDefault && (
                      <span className='px-2 py-1 text-xs bg-primary/10 text-primary rounded-full'>Default</span>
                    )}
                  </div>
                  <div className='space-y-1 text-sm'>
                    <p>{address.addressLine1}</p>
                    {address.addressLine2 && <p>{address.addressLine2}</p>}
                    <p className='text-muted-foreground'>
                      {[address.landmark, address.city, address.state, address.pincode, address.country]
                        .filter(Boolean)
                        .join(', ')}
                    </p>
                    {address.location?.coordinates && (
                      <p className='text-xs text-muted-foreground'>
                        Coordinates: {address.location.coordinates[1]}, {address.location.coordinates[0]}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className='text-sm text-muted-foreground text-center py-8'>No addresses found</p>
      )}
    </div>
  );
};

export default AddressesTab;
